/** Compact nav badge: 9+, 99+, 999+, … */
export const formatBadgeCount = (count) => {
  const n = Number(count) || 0;
  if (n > 999) return "999+";
  if (n > 99) return "99+";
  if (n > 9) return "9+";
  return String(n);
};
